export const ReactNativeFile = (_ref: any) => {
  var uri = _ref.uri,
    name = _ref.name,
    type = _ref.type;
  // @ts-ignore
  this.uri = uri;
  // @ts-ignore
  this.name = name;
  // @ts-ignore
  this.type = type;
};
